import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPartnersAndTools = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.6)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.5 0.5H1.41944C1.59262 0.5 1.67921 0.5 1.74889 0.531668C1.81029 0.559575 1.86233 0.604457 1.8988 0.660962C1.94018 0.72508 1.95243 0.810324 1.97692 0.980804L2.31009 3.3M2.31009 3.3L3.05054 8.71198C3.1445 9.39877 3.19148 9.74216 3.35659 10.0006C3.50207 10.2284 3.71065 10.4095 3.95721 10.5222C4.23703 10.65 4.58553 10.65 5.28253 10.65H11.3066C11.9701 10.65 12.3018 10.65 12.5729 10.5313C12.812 10.4266 13.017 10.2579 13.1652 10.044C13.3332 9.80133 13.3952 9.47726 13.5194 8.82913L14.4511 3.96478C14.4948 3.73667 14.5167 3.62261 14.485 3.53345C14.4572 3.45524 14.4024 3.38938 14.3304 3.34761C14.2482 3.3 14.1314 3.3 13.8979 3.3H2.31009ZM6.13138 13.8C6.13138 14.1866 5.81622 14.5 5.42746 14.5C5.03869 14.5 4.72354 14.1866 4.72354 13.8C4.72354 13.4134 5.03869 13.1 5.42746 13.1C5.81622 13.1 6.13138 13.4134 6.13138 13.8ZM11.7628 13.8C11.7628 14.1866 11.4476 14.5 11.0588 14.5C10.6701 14.5 10.3549 14.1866 10.3549 13.8C10.3549 13.4134 10.6701 13.1 11.0588 13.1C11.4476 13.1 11.7628 13.4134 11.7628 13.8Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgPartnersAndTools);
export default ForwardRef;
